/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Type_LocationInputs */



/**
* | output |
* | --- |
* | "Location" |
*
* @param {Knp_Terms_Type_LocationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_type_location = /** @type {((inputs?: Knp_Terms_Type_LocationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Type_LocationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lieu")
	if (locale === "de") return /** @type {LocalizedString} */ ("Standort")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Расположение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ubicación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("地点")
	if (locale === "ja") return /** @type {LocalizedString} */ ("位置")
	if (locale === "hi") return /** @type {LocalizedString} */ ("जगह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Localização")
	return /** @type {LocalizedString} */ ("Location")
});